import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { replaceUrlParam } from "../../common/utils";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CustomTable from "../../common/CustomTable";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchClientOrders,
  fetchClientOrderByID,
  fetchMoreOrders,
  getFullList,
  fetchOrderByID,
  fetchOrders,
  selectOrders,
  setOrder,
  setEditing,
  setError,
  error,
} from "./ordersSlice";
import { processOrders } from "./ordersSlice";
import Grid from "@material-ui/core/Grid";
import { fetchClients, selectClients } from "../clients/clientsSlice";
// import {fetchOrderUserByID} from '../users/usersSlice';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function OrdersContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [orderNames, setOrderNames] = useState([]);
  const [userIDs, setUserIDs] = useState([]);
  const edit = props.location.pathname.includes("edit");

  const {
    orders,
    error,
    loading,
    ordersList,
    ordersFilter,
    lastQuery,
    ordersAmount,
  } = useSelector(selectOrders);

  const { clients, clientsList } = useSelector(selectClients);
  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 5, value: "Pending", name: "Pending" },
    { id: 16, value: "Dispatched", name: "Dispatched" },
    { id: 9, value: "Completed", name: "Completed" },
    { id: 23, value: "Refunded", name: "Refunded" },
    { id: 24, value: "Processing", name: "Processing" },
  ]);

  const [numberShown, setNumberShown] = useState(100);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [dateBefore, setDateBefore] = useState("");
  const [dateAfter, setDateAfter] = useState("");
  const [client, setClient] = useState("");

  // console.log('dateBefore', dateBefore && dateBefore.toISOString())
  // console.log('dateAfter', dateAfter && dateAfter.toISOString())

  const urlParams = new URLSearchParams(window.location.search);

  const invoiceParam = urlParams.get("invoice");
  const orderParam = urlParams.get("order");
  // const nameParam = urlParams.get("name");
  // const clientParam = urlParams.get('client');

  useEffect(() => {
    if (orderParam) {
      dispatch(
        fetchOrderByID({
          token: jwtToken,
          orderID: orderParam,
        })
      );
    }
  }, [orderParam]);

  useEffect(() => {
    dispatch(fetchClients({ token: jwtToken, query: "" }));
  }, []);

  useEffect(() => {
    if (client) {
      let searchQuery = lastQuery ? lastQuery : "";

      if (rowsPerPage) {
        searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
      }

      dispatch(
        fetchOrders({
          token: jwtToken,
          query: searchQuery,
        })
      );

      setNumberShown(rowsPerPage);
    }
  }, [rowsPerPage]);

  const handleChange = (event) => {
    setClient(event.target.value);
    let searchQuery = `?limit=${rowsPerPage}`;

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }

    if (invoiceParam) {
      searchQuery = replaceUrlParam(searchQuery, "invoiceid", rowsPerPage);
    }

    searchQuery = replaceUrlParam(searchQuery, "clients", event.target.value);

    searchQuery = replaceUrlParam(searchQuery, "order_by", "id");

    searchQuery = replaceUrlParam(searchQuery, "sort", "desc");

    dispatch(
      fetchOrders({
        token: jwtToken,
        query: searchQuery,
      })
    );
    setSortDirection("desc");
    setSortProperty("id");

    setNumberShown(rowsPerPage);
  };
  // const handleChange = (event) => {
  //   setClient(event.target.value);
  //   dispatch(
  //     fetchOrders({
  //       token: jwtToken,
  //       query: `?clients=${event.target.value}&limit=${rowsPerPage}&sort=desc`,
  //     })
  //   );
  // };

  const headCells = [
    {
      id: "id",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Order #",
      long: false,
      sortable: true,
    },
    {
      id: "userDisplayName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Member",
      long: false,
    },
    {
      id: "totalProducts",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Products",
      long: false,
    },
    {
      id: "totalPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Point Total",
      long: false,
    },
    {
      id: "createdAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Order Date",
      long: false,
      sortable: true,
    },
    {
      id: "updatedAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Update",
      long: false,
      sortable: true,
    },
    {
      id: "statusID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Status",
      long: false,
      sortable: true,
    },
    {
      id: "invoicesByOrder",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "View Related Invoice",
      long: false,
    },
  ];

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > ordersList.length ? rowsPerPage : ordersList.length,
        query: searchQuery,
        targetLength: ordersAmount,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (ordersList.length < ordersAmount && ordersList.length < expectedLen) {
        dispatch(
          fetchMoreOrders({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (ordersList.length == ordersAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
      case "totalPoints":
        property = "total_points";
        break;
      case "clientID":
        property = "client_id";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchOrders({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleOrdersChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedOrder = ordersList.filter(
      (order) => order.orderNumber === event.target.value
    );
    selectedOrder && idsArr.push(selectedOrder[0].id);
    // });

    setOrderNames(event.target.value);
    setUserIDs(idsArr);
  };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  const handleEdit = (id) => {};

  const handleEditClick = (id) => {
    const selectedOrder = ordersList.filter((order) => order.id === id);
    console.log('selectedOrder', selectedOrder);
    dispatch(setOrder(selectedOrder[0]));
    dispatch(
      fetchOrderByID({
        orderID: selectedOrder[0].id,
        // clientID: selectedOrder[0].clientID,
        token: jwtToken,
      })
    );
    dispatch(setEditing(true));
  };

  const handleSearch = () => {
    let daterange = "";
    if (dateBefore && dateAfter) {
      daterange = `${dateAfter.toISOString().substring(0, 10)},${dateBefore
        .toISOString()
        .substring(0, 10)}`;
    } else if (dateBefore && !dateAfter) {
      daterange = `lte,${dateBefore.toISOString().substring(0, 10)}`;
    } else if (!dateBefore && dateAfter) {
      daterange = `gte,${dateAfter.toISOString().substring(0, 10)}`;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (daterange) {
      searchQuery = replaceUrlParam(searchQuery, "odate", daterange);
    }
    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchOrders({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setClient(null);
    setOrderNames([]);
    setUserIDs([]);
    setStatusNames([]);
    setStatusIDs([]);
    setDateAfter("");
    setDateBefore("");
    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchOrders({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const handleProcessInvoices = () => {
    if (client) {
      // let endDate = new Date();
      // // add a day
      // endDate.setDate(endDate.getDate() + 1);
      // const options = {
      //   year: "numeric",
      //   month: "2-digit",
      //   day: "2-digit",
      // };
      // let formattedDate = endDate
      //   .toLocaleDateString("tn-ZA", options)
      //   .split("/")
      //   .reverse()
      //   .join("-");
      dispatch(
        processOrders({
          token: jwtToken,
          clientID: client,
          startDate: dateBefore,
          endDate: dateAfter
          // endDate: formattedDate,
        })
      );
    }
  };

  const selectNames = ["status"];

  const [rowList, setRowList] = useState([...headCells]);

  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded" || loading === "idle") {
    content = (
      <CustomTable
        data={ordersList}
        actionsLists={[statusList]}
        actionsHandleChange={[handleStatusChange]}
        actionsNames={[statusNames]}
        headCells={headCells}
        cellList={cellList}
        handleEditClick={handleEditClick}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        area={"order"}
        selectNames={selectNames}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setDateBefore={setDateBefore}
        setDateAfter={setDateAfter}
        dateAfter={dateAfter}
        dateBefore={dateBefore}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={ordersAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <Dialog
        open={error}
        onClose={() => {
          dispatch(setError(""));
        }}
      >
        <DialogTitle>Error Processing Invoices</DialogTitle>
        <DialogContent style={{ padding: 20 }}>{error}</DialogContent>
      </Dialog>
      <Grid
        item
        sm
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 32,
          paddingRight: 32,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              marginRight: 24,
              padding: 0,
              marginLeft: 12,
              fontSize: 24,
              fontWeight: "bold",
              color: "#42494E",
              marginBottom: 0,
              marginTop: 4,
            }}
          >
            Select Client:
          </div>

          <div>
            <FormControl
              style={{ width: 250 }}
              margin="dense"
              className={classes.formControl}
            >
              <Select
                variant="outlined"
                value={client}
                margin="dense"
                onChange={handleChange}
                inputProps={{
                  name: "client",
                  id: "client-simple",
                }}
              >
                {clientsList.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        { client && (
        <div onClick={handleProcessInvoices}>
          <ColorButton key={client.id} disabled={!client}>
            Process Invoices
          </ColorButton>
        </div>
        )}
      </Grid>

      {content}
    </Grid>
  );
}
